module.exports = __webpack_public_path__ + "static/media/323.bcc409b2.webp";